import * as signalR from '@microsoft/signalr'

let conexao = null
let isExplicitDisconnect = false
const urlApi = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export function conectar(conversaId, onReceber, onCarregar, onMensagemLida, onUsuarioEmAtendimentoAtualizado) {
    if (conexao && conexao.state === signalR.HubConnectionState.Connected) {
        return Promise.resolve();
    }
    conexao = new signalR.HubConnectionBuilder()
        .withUrl(`${urlApi}/administracao/mensagens-hub`, {
            transport: signalR.HttpTransportType.WebSockets,
            accessTokenFactory: () => localStorage.getItem('token')
        })
        .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: (context) => {
                if (isExplicitDisconnect) return null;
                return Math.min(context.elapsedMilliseconds * 2, 10000);
            }
        })
        .configureLogging(signalR.LogLevel.Warning)
        .build()

    //handlers
    conexao.on('ReceberMensagens', (mensagemData) => {
        if (onReceber) {
            onReceber(
                mensagemData.usuario,
                mensagemData.usuarioId,
                mensagemData.texto,
                mensagemData.dataEnvio,
                0,
                mensagemData.id,
                mensagemData.tipo || 0,
                mensagemData.conteudoImagem,
                []
            )
        }
    })

    conexao.on('CarregarMensagens', onCarregar)

    // Atualizado para usar o nome correto do evento
    conexao.on('MensagemStatusAtualizado', (notificacao) => {
        if (onMensagemLida) {
            onMensagemLida(notificacao)
        }
    })

    if (onUsuarioEmAtendimentoAtualizado) {
        conexao.on('UsuarioEmAtendimentoAtualizado', onUsuarioEmAtendimentoAtualizado)
    }

    conexao.onclose((error) => {
        if (!isExplicitDisconnect && error) {
            console.warn('Conexão mensagens fechada, tentando reconectar...', error);
            setTimeout(() => conectar(conversaId, onReceber, onCarregar, onMensagemLida, onUsuarioEmAtendimentoAtualizado), 2000);
        }
    });

    conexao.onreconnected(() => {
        if (conversaId) {
            safeInvoke('AcessarConversa', String(conversaId))
        }
    });

    return conexao.start()
        .then(() => {
            return safeInvoke('AcessarConversa', String(conversaId));
        })
        .catch(err => {
            console.error('Falha na conexão SignalR mensagens:', err);
            conexao = null;
            throw err;
        });
}

export async function uploadImagem(arquivo) {
    const dadosFormulario = new FormData()
    dadosFormulario.append('imagem', arquivo)

    // Configura timeout baseado no tamanho do arquivo
    const timeoutMs = Math.max(30000, arquivo.size / 1024) // Min 30s, +1s por KB

    const controller = new AbortController()
    const idTimeout = setTimeout(() => controller.abort(), timeoutMs)

    try {
        const response = await fetch(`${urlApi}/administracao/imagens`, {
            method: 'POST',
            body: dadosFormulario,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            signal: controller.signal
        })

        clearTimeout(idTimeout)

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`)
        }

        const result = await response.json()
        return result

    } catch (error) {
        clearTimeout(idTimeout)
        if (error.name === 'AbortError') {
            throw new Error('Upload cancelado por timeout')
        }
        console.error('Erro no upload:', error)
        throw error
    }
}

function safeInvoke(method, ...args) {
    if (conexao && conexao.state === signalR.HubConnectionState.Connected) {
        return conexao.invoke(method, ...args)
    } else {
        console.warn(`Tentativa de invocar ${method} sem conexão ativa. Estado atual:`, conexao?.state)
        return Promise.reject(new Error('Conexão não está aberta'))
    }
}

export function enviarMensagem(conversaId, usuario, usuarioId, texto, tipo = 0, conteudoImagem = null) {
    return safeInvoke(
        'EnviarMensagem',
        conversaId,
        usuario,
        usuarioId,
        texto,
        tipo,
        conteudoImagem
    )
}

export function marcarComoLida(conversaId, usuarioId, ids) {
    if (!conversaId || !usuarioId) {
        console.error('marcarComoLida: conversaId ou usuarioId inválidos', { conversaId, usuarioId })
        return Promise.reject(new Error('Parâmetros inválidos'))
    }

    if (!ids || !Array.isArray(ids) || ids.length === 0) {
        console.warn('marcarComoLida: nenhum ID de mensagem fornecido', ids)
        return Promise.resolve()
    }

    const idsValidos = ids.filter(id => id && id !== 'undefined' && id !== 'null')

    if (idsValidos.length === 0) {
        console.warn('marcarComoLida: nenhum ID válido após filtragem', ids)
        return Promise.resolve()
    }

    return safeInvoke('MarcarComoLida', String(conversaId), usuarioId, idsValidos);
}

export function recarregarConversa(conversaId) {
    return safeInvoke('AcessarConversa', String(conversaId));
}

export function desconectar() {
    isExplicitDisconnect = true;
    if (conexao) {
        return conexao.stop();
    }
    return Promise.resolve();
}
